import { render, staticRenderFns } from "./buy-more-discount.vue?vue&type=template&id=26cc841d"
import script from "./buy-more-discount.vue?vue&type=script&lang=ts"
export * from "./buy-more-discount.vue?vue&type=script&lang=ts"
import style0 from "./buy-more-discount.vue?vue&type=style&index=0&id=26cc841d&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports